module.exports = __webpack_public_path__ + "static/img/atoshi_logo.521d68a.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/AtomicChain/assets/atoshi_logo.png
// module id = HSHW
// module chunks = 3